import React, { useEffect, useRef } from 'react';

import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { getHistoricalData } from '../../../data/store/portfolio/portfolioActions';
import { LineMulti } from '../../../components/charts/LineMulti/LineMulti';
import Spinner from '../../Model/Spiner/Sriner';

function Standings({ selectedRowKeys, theme }) {
  const dispatch = useDispatch();
  const timeoutID = useRef();

  const {
    isLoading,
    value_development,
    portfolioList: { list },
  } = useSelector((state) => state.portfolioReducer);

  useEffect(() => {
    clearTimeout(timeoutID.current);
    if (selectedRowKeys) {
      timeoutID.current = setTimeout(() => {
        dispatch(getHistoricalData([selectedRowKeys]));
      }, 1500);
    }
    return () => {
      dispatch({ type: 'CLEAR_HISTORICAL_DATA' });
      clearTimeout(timeoutID.current);
    };
  }, [selectedRowKeys, dispatch]);

  return (
    <div className="chart-linemulti-wrapper">
      {isLoading ? (
        <Spinner position="absolute" width="100%" height="100%" />
      ) : (
        <LineMulti data={value_development} list={list} theme={theme} />
      )}
    </div>
  );
}

export default Standings;

Standings.propTypes = {
  theme: PropTypes.string,
  selectedRowKeys: PropTypes.number,
};
